import { Component } from '@angular/core';
import { IGenericCrudConfiguration } from 'src/app/libs/components/generic-crud/generic-crud.component';
import { TechnicalFeature, ValueTypes } from 'src/app/models';
import { MasterApiService } from 'src/app/services/master-api.service';
import { ProductsTechnicalFeaturesAddComponent } from './products-technical-features-add/products-technical-features-add.component';
import { ProductsTechnicalFeaturesEditComponent } from './products-technical-features-edit/products-technical-features-edit.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-products-technical-features',
    templateUrl: './products-technical-features.component.html',
    styleUrls: ['./products-technical-features.component.css'],
    standalone: false
})
export class ProductsTechnicalFeaturesComponent {

  config?: IGenericCrudConfiguration<TechnicalFeature>;

  constructor(private api: MasterApiService,  private tr: TranslateService){

    this.config = {
      resource: this.api.resources.product.technicalfeatures,
      entityFields: {
        code: {isLink: true},
        name: {isLink: true},
        valueTypeId: {
          lookup: {
            dataSource: ValueTypes.map(x => ({ id: x.id, name: this.tr.instant(`enumeration.ValueTypes.${x.name}`) })),
            displayExpr: 'name',
            valueExpr: 'id',
          }
        },
        values:{}

      },
      editComponent: ProductsTechnicalFeaturesEditComponent,
      createComponent: ProductsTechnicalFeaturesAddComponent,
      crudButtons: {
        canDelete: true
      }
    }
  }
}
